import { AppDispatch, RootState } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { selectHistoricalRunsheetsWithShifts } from '../selectors/runsheetsSelectors'
import { removeMultipleRunsheetShifts } from '../slices/runsheetShiftsSlice'
import { removeMultipleRunsheets } from '../slices/runsheetsSlice'

export const clearHistoricalRunsheets = createAsyncThunk<void, void, { state: RootState, dispatch: AppDispatch }>(
  'runsheets/clearHistorical',
  async (_, { getState, dispatch }) => {
    const state = getState()
    const historicalRunsheets = selectHistoricalRunsheetsWithShifts(state)

    dispatch(removeMultipleRunsheets(historicalRunsheets.map(runsheet => runsheet.id)))
    dispatch(removeMultipleRunsheetShifts(historicalRunsheets.flatMap(runsheet => runsheet.shifts.map(shift => shift.id))))
  })